import React, { useState, useEffect } from 'react';
import { setIsLoading } from '../../Redux/store/authSlice';
import SearchIcon from '@mui/icons-material/Search';
import SyncIcon from '@mui/icons-material/Sync';
import TuneIcon from '@mui/icons-material/Tune';
import { Checkbox, IconButton } from '@mui/material';
import { Edit, MoreVert } from '@mui/icons-material';
import { Icon } from '@iconify/react';
import './CustomerManData.css';
import FilterCustMan from './FilterCustMan';
import { useSelector, useDispatch } from 'react-redux';

const CustomerManData = () => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState(null); 
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const userToken = useSelector((state) => state.auth.token);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const dispatch = useDispatch();

 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          'https://localhost:7040/api/enrolledscheme/customermanagement',
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${userToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (Array.isArray(data)) {
          setCustomers(data);
        } else {
          console.error('Unexpected data format:', data);
          setCustomers([]);
        }
      } catch (error) {
        console.error('Error fetching customer data:', error);
      }
    };

    if (userToken) fetchData();
  }, [userToken]);

  const handleClick = () => {
    setIsSpinning(true);
    setTimeout(() => {
      setIsSpinning(false);
    }, 1000);
  };

  const handleCheckboxChange = (id) => {
    setCheckedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleFilterClick = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

 
  const handleFilterData = (data) => {
    setFilteredCustomers(data); 
    handleClosePopup();
    setCurrentPage(1); 
  };

  const totalItems = (filteredCustomers || customers).length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const paginatedCustomers = (filteredCustomers || customers).slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (direction) => {
    setCurrentPage((prevPage) =>
      direction === 'next'
        ? Math.min(prevPage + 1, totalPages)
        : Math.max(prevPage - 1, 1)
    );
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="search-filter-out">
        <div className="search-cont">
          <h4>
            <SearchIcon className="mat-icon" />
            Search...
          </h4>
          <p>You can search by scheme, scheme no..</p>
        </div>
        <div className="sync-filt-out">
          <div className="sync-cont" onClick={handleClick}>
            <SyncIcon className={`mat-icon ${isSpinning ? 'spin' : ''}`} />
            Refresh
          </div>
          <div className="filter-cont" onClick={handleFilterClick}>
            <TuneIcon className="mat-icon" />
            Filter
          </div>
        </div>
      </div>
      {isPopupVisible && (
        <FilterCustMan
          onClose={handleClosePopup}
          onFilterData={handleFilterData} 
        />
      )}
      <div className="admin-crm-out">
        <div className="table-wrapper">
          {isLoading ? (
            <p>Loading...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th className="header-cell">
                    <div className="header-content">
                      <Checkbox /> Full Name
                      <Icon icon="icon-park-solid:sort" className="sort-icon" />
                    </div>
                  </th>
                  <th className="header-cell">
                    <div className="header-content">
                      Customer ID
                      <Icon icon="icon-park-solid:sort" className="sort-icon" />
                    </div>
                  </th>
                  <th className="header-cell">
                    <div className="header-content">
                      Date Created
                      <Icon icon="icon-park-solid:sort" className="sort-icon" />
                    </div>
                  </th>
                  <th className="header-cell">
                    <div className="header-content">
                      Scheme
                      <Icon icon="icon-park-solid:sort" className="sort-icon" />
                    </div>
                  </th>
                  <th className="header-cell">
                    <div className="header-content">
                      Status
                      <Icon icon="icon-park-solid:sort" className="sort-icon" />
                    </div>
                  </th>
                  <th className="header-cell">
                    <div className="header-content">
                      <Icon icon="line-md:edit-twotone" className="edit-icon" />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedCustomers.map((customer) => (
                  <tr key={customer.customerEnrolledSchemeId}>
                    <td>
                      <Checkbox
                        checked={
                          checkedItems[customer.customerEnrolledSchemeId] || false
                        }
                        onChange={() =>
                          handleCheckboxChange(customer.customerEnrolledSchemeId)
                        }
                      />
                      {customer.fullName}
                    </td>
                    <td>{customer.customerId}</td>
                    <td>{new Date(customer.dateCreated).toLocaleDateString()}</td>
                    <td>{customer.schemeName}</td>
                    <td className="status-cell">
                    <span
    className={
      customer.status === 'Authorized'
        ? 'status-paid'
        : 'status-not-paid'
    }
  >
    {customer.status === 'Authorized' ? 'Paid' : 'Not Paid'}
  </span>
                    </td>
                    <td>
                      <IconButton>
                        <MoreVert />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="download-out">
          <div className="down-cont">
            <Icon icon="ph:download" className="download-cont-icon" />{' '}
            <span>Download Selected</span>
          </div>
          <div className="show-no-cont">
            <div className="show-cont">
              Showing
              <div className="count-cont">
                <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              {Math.min((currentPage - 1) * itemsPerPage + 1, totalItems)} -{' '}
              {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
            </div>
            <div className="arrow-cont">
              <Icon
                icon="iconamoon:arrow-left-2-bold"
                className="down-icon-arrow"
                onClick={() => handlePageChange('prev')}
              />
              <Icon
                icon="iconamoon:arrow-right-2-bold"
                className="down-icon-arrow"
                onClick={() => handlePageChange('next')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerManData;
